// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"265":"caf979ac","302":"cb96d59d","401":"a13d79c5","542":"4ff987c7","566":"1adbff2d","840":"24dcfcfa"}[chunkId] + ".chunk.css";
};